/** The avatar letter for a name: its first letter or digit, so "[SIM LIVE] Fashion" reads "S", not "[". */
export function initialOf(name: string | undefined | null, fallback: string): string {
  const m = name?.match(/[\p{L}\p{N}]/u)
  return m ? m[0].toUpperCase() : fallback
}
